import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import CartItem from "../Components/CartItem";
import ContentBlock from "../Components/ContentBlock";
import Footer from "../Components/Footer";
import TopNavBar from "../Components/TopNavBar";
import { getCartItems, getCartTotal, removeFromCart, updateCartQuantity, isLoggedIn } from "../Session/Session";

class CartPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: 'Pirkinių krepšelis',
      cartItems: [],
      cartTotal: 0,
    };

    this.removeItemFromCart = this.removeItemFromCart.bind(this);
    this.updateCartTotal = this.updateCartTotal.bind(this);
  }

  componentDidMount() {
    this.setState({
      cartItems: getCartItems(),
      cartTotal: getCartTotal(),
    });
  }

  removeItemFromCart = (id) => {
    removeFromCart(id);
    this.setState({
      cartItems: getCartItems(),
      cartTotal: getCartTotal(),
    });
  }

  updateCartTotal = (id, quantity) => {
    var item = this.state.cartItems.find(x => x.id === id);
    item.quantity = quantity;
    updateCartQuantity(id, quantity);

    this.setState({
      cartTotal: getCartTotal(),
    });
  }

  render() {

    const pageStyle = {
      backgroundImage: "url(apie-page-background.png)",
      height: '100vh',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    };

    var nextBtn = isLoggedIn() ?
      <Button variant="outline-light" className="btn-lg btn-block mt-3" href="/apmokejimas">Apmokėti</Button> :
      <>
        <Button variant="outline-light" className="btn-lg btn-block mt-3" href="/prisijungimas">Prisijungti</Button>
        &nbsp;
        <Button variant="outline-light" className="btn-lg btn-block mt-3" href="/apmokejimas">Tęsti neprisijungus</Button>
      </>
      ;

    return (
      <Container fluid style={pageStyle}>
        <TopNavBar activeRoute={8} />
        <h1 className='page-title'>{this.state.pageName}</h1>
        <Container>
          <ContentBlock>
            {this.state.cartItems.map((item, index) => {
              return <CartItem
                Id={item.id}
                Name={item.name}
                Price={item.price}
                Image={item.image ?? ''}
                Quantity={item.quantity}
                key={index}
                removeItemFromCart={this.removeItemFromCart.bind(this)}
                updateCartTotal={this.updateCartTotal.bind(this)}
              />
            })
            }
            <Row>
              <Col xs={12} md={12} lg={12}>
                <h3 className='text-right mt-2'>Iš viso: {this.state.cartTotal} €</h3>
              </Col>
            </Row>
            <Row>
              <Col xs={6} md={6} lg={6}>
                <Form.Control type="text" placeholder="Nuolaidos kodas" className="mt-2" />
                <Form.Text className="text-muted"> Įveskite nuolaidos kodą </Form.Text>
                <Form.Control type="submit" value="Pritaikyti" className="mt-2" />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12} lg={12}>
                {nextBtn}
              </Col>
            </Row>
          </ContentBlock>
        </Container>
        <Footer></Footer>
      </Container>
    );
  }
}

export default CartPage;